export const GOOGLE_API_KEY = 'GoogleMapsApiKey'